const { $ } = window;

const CHECKBOX_PATTERN = 'check_';

window.YP.FormManager = () => ({
    init() {
        $('.form-ajax').on('submit', this.ajaxFormSubmit);
        const checkboxPatternRegExp = new RegExp(`.*${CHECKBOX_PATTERN}`);
        $('.c-form input:checkbox')
            // Only get checkbox containing the checkbox pattern
            // Not possible yet with stable CSS selector
            .filter((_, e) => checkboxPatternRegExp.test(e.id))
            .on('click', (e) => {
                const currentCheckbox = e.currentTarget;
                // Retrieve the related DOM element according the current checkbox id
                const toggledDOMClass = currentCheckbox.id.replace(checkboxPatternRegExp, 'toggle_');
                const toggledDOMElement = $(`.${toggledDOMClass}`);
                toggledDOMElement.toggle();
                // Reset the input value when the toggled element is hidden
                if (toggledDOMElement.is(':visible')) {
                    return;
                }
                if (!$(toggledDOMElement).hasClass('toggle_skip_value_edit')) {
                    // Reset the standard related input
                    toggledDOMElement.find('input:text').val(null);
                    toggledDOMElement.find('input:checkbox').val(null);
                }
                // Reset the related select2 input
                if (!currentCheckbox.dataset || !currentCheckbox.dataset.childNode) {
                    return;
                }
                const { childNode } = currentCheckbox.dataset;
                $(`#s2id_${childNode}`).select2('val', null);
            });

        function updateToggleRadio(radio) {
            const toggledDOMClass = `toggle_${radio.id.replace(`_${radio.value}`, '')}`;
            const toggledDOMElement = $(`.${toggledDOMClass}`);
            toggledDOMElement.each((index, element) => {
                const domElement = $(element);
                const domElementValues = (`${domElement.data('value')}` ?? '').split(',');
                if (domElementValues.indexOf(radio.value) > -1) {
                    domElement.show();
                    domElement.find('input.geoapify-autocomplete-input').attr('required', true);
                } else {
                    domElement.hide();
                    domElement.find('input.geoapify-autocomplete-input').attr('required', false);
                    if (!domElement.hasClass('toggle_skip_value_edit')) {
                        domElement.find('input:text').val(null);
                        domElement.find('input:checkbox').prop("checked", false);
                    }
                }
            });
        }
        $('.c-form input:radio').on('click', (e) => {
            updateToggleRadio(e.currentTarget);
        });

        $('.c-form input:radio').each(function updateEachToggleRadio() {
            if ($(this).prop('checked')) {
                updateToggleRadio(this);
            }
        });
        $('.c-form input:radio.enableAfterInit').removeAttr('disabled');
    },
    ajaxFormSubmit() {
        const form = $(this);
        if (form.data('submitting')) {
            return false;
        }
        form.data('submitting', true);
        const text = form.find('button:submit').html();

        form.find('input').attr('readonly', 'readonly');
        form.find('button:submit').attr('disabled', 'disabled');
        form.find('button:submit').html('<i class="fa fa-spinner fa-spin fa-lg"></i>');

        const options = {
            dataType: 'json',
            success(data) {
                form.data('submitting', false);
                form.find('button:submit').removeAttr('disabled');
                form.find('button:submit').html(text);
                form.find('input').removeAttr('readonly');
                if (data.status === 'error') {
                    form.find('fieldset').html(data.view);
                    return;
                }
                if (data.view) {
                    $('.ajax-container').html(data.view);
                } else if (data.array_elements) {
                    data.array_elements.forEach((element, key) => {
                        if (!$('.ajax-container').find(`#${key}`)) {
                            return;
                        }
                        if (data.switch_class) {
                            element.toggleClass(data.switch_class);
                        }
                    });
                }
                form.find("input[type!='hidden']").val('');
                form.find('.error_list').remove();
                if (!data.message) {
                    return;
                }
                window.YP.NotifManager().show({
                    message: data.message,
                    class: 'success',
                });
            },
            error() {
                form.data('submitting', false);
                form.find('button:submit').removeAttr('disabled');
                form.find('button:submit').html(text);
                form.find('input').removeAttr('readonly');
                const notification = {};
                notification.message = 'Une erreur est survenue lors de la validation du formulaire';
                notification.class = 'error';
                window.YP.NotifManager().show(notification);
            },
        };
        form.ajaxSubmit(options);
        return false;
    },
});

window.addEventListener('load', () => window.YP.FormManager().init());
